import {Component, Input, OnInit} from '@angular/core';
import {
    BaseModalComponent,
    FeatureKeys,
    LoadingService,
    Menu,
    MenuItemModifier,
    MenuItemModifierSelection,
    MenuModifier,
    MenuModifierGroup,
    MenuModifierGroupModifier,
    MenuModifierGroupSelection,
    MenuModifierGroupSelectionOption,
    MenuModifierGroupService,
    MenuModifierSelection,
    MenuService,
    ToastService
} from 'brewbill-lib';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'bb-edit-menu-modifier-group',
    templateUrl: './edit-menu-modifier-group.component.html',
    styleUrls: ['./edit-menu-modifier-group.component.scss'],
})
export class EditMenuModifierGroupComponent extends BaseModalComponent implements OnInit {

    @Input() modifierGroup: MenuModifierGroup;
    @Input() addMenuModifier: any;
    @Input() addMenuModifierSelection: any;

    menu: Menu;
    selectedModifiers: any[] = [];
    selectModifierType = false;
    formGroup: FormGroup = new FormGroup({});

    protected readonly featureKeys = FeatureKeys;

    constructor(
        modalController: ModalController,
        private formBuilder: FormBuilder,
        private menuService: MenuService,
        private toastService: ToastService,
        private menuModifierGroupService: MenuModifierGroupService,
        private loadingService: LoadingService
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.menu = this.menuService.currentValue;
        this.modifierGroup = this.modifierGroup == null ? new MenuModifierGroup() : this.modifierGroup;

        this.selectedModifiers = this.modifierGroup.modifiers == null ? [] :
            [...this.modifierGroup.modifiers, ...this.modifierGroup.selections];

        this.formGroup = this.formBuilder.group(
            {
                id: this.modifierGroup.id,
                parentId: this.menu.id,
                name: [this.modifierGroup.name, Validators.required],
                description: this.modifierGroup.description
            }
        );

        this.subscribe(this.menuService.current.subscribe(m => {
            this.menu = !!m ? new Menu(m) : null;
        }));
    }

    valid() {
        return this.formGroup.valid && !!this.selectedModifiers && this.selectedModifiers.length > 0;
    }

    buildModifierItem(item: any, sortOrder: number) {
        if (!!item.options) {
            const options: MenuModifierGroupSelectionOption[] = [];
            item.options.forEach(o => options.push(new MenuModifierGroupSelectionOption({
                menuModifier: o.menuModifier,
                additionalPrice: null
            })));

            return new MenuItemModifierSelection({
                menuModifierSelection: item as MenuModifierSelection,
                sortOrder,
                options
            });
        } else {
            return new MenuItemModifier({
                menuModifier: item as MenuModifier,
                additionalPrice: null,
                sortOrder
            });
        }
    }

    async openAddMenuModifier() {
        const l = await this.addMenuModifier(null);
        if (l != null) {
            const modifierGroupModifier = new MenuModifierGroupModifier();
            modifierGroupModifier.menuModifier = l;
            modifierGroupModifier.sortOrder = this.selectedModifiers.length + 1;
            this.selectedModifiers = [...this.selectedModifiers, modifierGroupModifier];
        }
    }

    async openAddMenuModifierSelection() {
        const l = await this.addMenuModifierSelection(null);
        if (l != null) {
            const options: MenuModifierGroupSelectionOption[] = [];
            l.options.forEach(o => options.push(new MenuModifierGroupSelectionOption({
                menuModifier: o.menuModifier,
                additionalPrice: null
            })));

            const mit = new MenuModifierGroupSelection({
                menuModifierSelection: l as MenuModifierSelection,
                sortOrder: this.selectedModifiers.length,
                options
            });

            this.selectedModifiers = [...this.selectedModifiers, mit];
        }
    }

    onSubmit() {
        this.loadingService.present();
        const menuModifierGroup: MenuModifierGroup = new MenuModifierGroup(this.formGroup.value);
        menuModifierGroup.modifiers = this.selectedModifiers.filter(m => !!m.menuModifier);
        menuModifierGroup.selections = this.selectedModifiers.filter(m => !!m.menuModifierSelection);

        if (menuModifierGroup.id != null) {
            this.menuModifierGroupService.update(menuModifierGroup).subscribe(
                async (t: MenuModifierGroup) => {
                    this.loadingService.dismiss();
                    await this.close(t);
                }, error => {
                    if (error.status === 422) {
                        this.toastService
                            .error('The modifier selection is out of sync from a previous change. Please refresh to make changes.');
                    }
                    this.close();
                }
            );
        } else {
            this.menuModifierGroupService.create(menuModifierGroup).subscribe(
                async (t: MenuModifierGroup) => {
                    this.loadingService.dismiss();
                    await this.close(t);
                }
            );
        }
    }
}
